import {Crud} from '@shared/services/crud';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CrudImplementation extends Crud {

  // The end point url is without trailing slash
  protected url = '/v1/admin/xxx';

  createEntity(entity: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entity));

    const url = this.url;
    return this.http.post(this.serverRoot + url, formData);
  }

  getEntity(id: string): Observable<any> {
    const url = this.url + '/' + id;
    return this.http.get(this.serverRoot + url);
  }

  getEntities(): Observable<any> {
    const url = this.url;
    return this.http.get(this.serverRoot + url);
  }

  updateEntity(id: string, entity: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entity));

    const url = this.url + '/' + id;
    return this.http.post(this.serverRoot + url, formData);
  }

  removeEntity(id: string): Observable<any> {
    const url = this.url + '/' + id;
    return this.http.delete(this.serverRoot + url);
  }
}
